import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

type ActiveSpaceLimitDialogProps = {
  open: boolean;
  onClose: () => void;
  onNavigateBilling: () => void;
};

export const ActiveSpaceLimitDialog = ({
  open,
  onClose,
  onNavigateBilling,
}: ActiveSpaceLimitDialogProps) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle>Upgrade to create more spaces</DialogTitle>
    <DialogContent>
      <Typography>
        You can have up to 3 active spaces on your current plan. Upgrade to create more
        boards, whiteboards, collages, and Quick Sorts.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        variant="contained"
        onClick={() => {
          onClose();
          onNavigateBilling();
        }}
      >
        Upgrade
      </Button>
    </DialogActions>
  </Dialog>
);
